import { BaseMapper } from '@ps/utils';

import { CompanyMarginDto } from '../dtos/company-margins.dto';
import { CompanyMargin } from '../../state/company-margins/company-margins-state.model';

export class CompanyMarginsMapper extends BaseMapper<
  CompanyMarginDto,
  CompanyMargin
> {
  public override fromDto(dto: CompanyMarginDto): CompanyMargin {
    return {
      buyerId: dto.buyer_id,
      supplierId: dto.supplier_id,
      countryId: dto.country_id,
      languageId: dto.language_id,
      margin: dto.margin,
      history: dto.history,
    };
  }
}
